export default __webpack_public_path__ + "0269fa94724fbea1c9c3fb90b14791e8.svg";